import React from 'react'

import Page from '../../../../components/pdf/Page'
import CiiPageContent from '../cii/PageContent'
import PropostaComercialPageContent from '../proposta-comercial/PageContent'
import BisPageContent from '../bis/PageContent'
import ProformaPageContent from '../proforma/PageContent'
import FormularioPageContent from '../formulario/PageContent'
import Header from '../formulario/section/Header'

const PdfDocument = ({ templateId }) => {
  const content = () => {
    if (templateId === 1) {
      return (
        <Page>
          <PropostaComercialPageContent />
        </Page>
      )
    }
    if (templateId === 2) {
      return (
        <Page>
          <BisPageContent />
        </Page>
      )
    }
    if (templateId === 3) {
      return (
        <Page>
          <CiiPageContent />
        </Page>
      )
    }
    if (templateId === 4) {
      return (
        <Page>
          <ProformaPageContent />
        </Page>
      )
    }
    if (templateId === 5) {
      return (
        <Page header={<Header />}>
          <FormularioPageContent />
        </Page>
      )
    }
  }
  return <>{content()}</>
}

export default PdfDocument
